export type SingleCallAsyncState = "idle" | "calling";

export class SingleCallAsync {
  public state: SingleCallAsyncState;
  public isLastCallSuccessful: boolean;

  constructor(public readonly asyncFunction: () => Promise<void>) {
    this.state = "idle";
    this.isLastCallSuccessful = true;
  }

  async call(): Promise<boolean> /* return if the call was made */ {
    if (this.state === "calling") return false;
    this.state = "calling";
    try {
      await this.asyncFunction();
    } catch (err) {
      this.isLastCallSuccessful = false;
      throw err;
    }
    this.state = "idle";
    return true;
  }
}
